import { formatClock } from '../lib/format.ts';

/** Always visible when the server runs with SIMULATED_CLOCK: answers refer to that moment. */
export function SimulatedClock({ now }: { now: string }) {
  return (
    <div
      role="status"
      className="tabular border-b border-gold/50 bg-cream-200 px-4 py-1 text-center text-sm font-semibold text-burgundy dark:bg-night-700 dark:text-burgundy-300"
    >
      Reloj simulado: {formatClock(new Date(now))}
    </div>
  );
}
